import { render, staticRenderFns } from "./TerminosPagador.vue?vue&type=template&id=08730bfe&scoped=true"
import script from "./TerminosPagador.vue?vue&type=script&lang=js"
export * from "./TerminosPagador.vue?vue&type=script&lang=js"
import style0 from "./TerminosPagador.vue?vue&type=style&index=0&id=08730bfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08730bfe",
  null
  
)

export default component.exports